export const SIDEBAR_DIMENSIONS = {
  /** Main sidebar width when expanded (px) */
  MAIN_EXPANDED_PX: 256,
  /** Main sidebar width when collapsed (px) */
  MAIN_COLLAPSED_PX: 72,
  /** Main sidebar width when expanded (CSS string) */
  MAIN_EXPANDED_WIDTH: '256px',
  /** Main sidebar width when collapsed (CSS string) */
  MAIN_COLLAPSED_WIDTH: '72px',
  /** Extended/settings sidebar width (px) */
  EXTENDED_WIDTH_PX: 256,
  /** Extended/settings sidebar width (CSS string) */
  EXTENDED_WIDTH: '256px',
  /** Top bar height (px) */
  TOP_BAR_HEIGHT_PX: 64,
  /** Top bar height (CSS string) */
  TOP_BAR_HEIGHT: '64px',
  /** Logo section height */
  LOGO_SECTION_HEIGHT: '64px',
  /** Logo width when sidebar collapsed */
  LOGO_COLLAPSED_WIDTH: '30px',
  /** Logo width when sidebar expanded */
  LOGO_EXPANDED_WIDTH: '198px',
  /** Logo margin left when collapsed */
  LOGO_COLLAPSED_MARGIN_LEFT: '8px',
} as const;

export const ANIMATION_DURATION = 300;

/**
 * CSS filter to convert icon to active state color, brand navy (#071834).
 * Uses brightness, saturation, invert, sepia, hue-rotate, and contrast filters.
 * An approximation: check it on screen, image icons only.
 */
export const ACTIVE_ICON_FILTER =
  'brightness(0) saturate(100%) invert(8%) sepia(31%) saturate(2780%) hue-rotate(201deg) brightness(93%) contrast(99%)';

/**
 * CSS filter to convert icon to inactive state color (#1f1f1f).
 * Uses brightness and invert filters to achieve the dark gray color.
 * Formula: brightness(0) makes icon black, then invert(12%) produces #1f1f1f.
 * Increased to invert(18%) for better visibility with FontAwesome icons.
 */
export const INACTIVE_ICON_FILTER = 'brightness(0) saturate(100%) invert(18%)';

/**
 * Z-index values for layering UI components.
 *
 * Z-index hierarchy:
 * - z-15: Dropdown menus in topbar (below topbar, above content)
 * - z-20: Topbar, extended sidebar
 * - z-30: Main sidebar
 * - z-50: Tooltips, dialogs, modals, overlays, copilot drawer
 */
export const Z_INDEX = {
  DROPDOWN_MENU: 15, // Below topbar (z-20), above content
  TOPBAR: 20,
  SIDEBAR_EXTENDED: 20,
  SIDEBAR_MAIN: 30,
  TOOLTIP: 50,
  DIALOG: 50,
  MODAL: 50,
  OVERLAY: 50,
  COPILOT_DRAWER: 50,
} as const;
